enum MediaContentStatus {
  DRAFT,
  PUBLISHED,
  DELETED,
  REVIEW,
  REVIEW_APPROVED,
  REVIEW_COMPLETED,
  SCHEDULED = 100,
}

export default MediaContentStatus;
